module.exports = __webpack_public_path__ + "img/blackjack1.bbbfe1f4.png";